import { useTelemetry } from '@iamexperiences/ecos-telemetry';
import { useMutation } from 'react-query';

import { HttpRequestError } from '../../shared/HttpRequestError';
import { IAgreementIdentifiers } from '../models/types';
import { settingsManager } from '../../shared/settings';
import { getRequestBody } from '../utilities/getRequestBody';

export const useDeclineAgreement = () => {
  const telemetry = useTelemetry();
  // This hook is only used in unauthenticated flow and should always use access token from the request body
  const { accessToken, recordDeviceId } = getRequestBody();

  return useMutation({
    mutationFn: async (props: IAgreementIdentifiers) => {
      const url = new URL(
        `${settingsManager.get('myAccountBackendUrl')}/api/termsofuse/agreements/${props.agreementId}/policyfiles/${
          props.policyFileId
        }/decline`,
      );
      url.searchParams.append('recordDeviceId', recordDeviceId.toString());
      const token = accessToken;
      const response = await fetch(url.toString(), {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });

      if (!response.ok) {
        const error = new HttpRequestError(response.status, response.statusText);
        telemetry.error('Error declining agreement', error);

        throw error;
      }
    },
  });
};
